<script setup lang="ts">
defineProps({
	message: {
		type: String,
		default: 'Get started today',
	},
});
</script>

<template>
	<section class="get-started-section">
		<div class="section-inner">
			<h1 class="message">
				{{ message }}
			</h1>
			<slot name="button" />
		</div>
	</section>
</template>

<style lang="scss" scoped>
.get-started-section {
	padding: spacings-get(12) 0;
	color: colors-get(base, white);
	background-color: colors-get(gray, 600);

	.section-inner {
		display: grid;
		gap: spacings-get(6);
	}

	.message {
		@include fonts-get(semibold, display-md);

		@include media-query-max(mobile) {
			@include fonts-get(semibold, display-sm);
		}
	}
}
</style>
